module.exports = __webpack_public_path__ + "media/images/countrysquared/bs-d7d97a0f8413e140dfa8f9f0a1400528.svg";